/* global fromShopify */

import _kebabCase from 'lodash/kebabCase'
import { VueHammer } from 'vue2-hammer'
import store from './store'
import jQuery from 'jquery'
import Vue from 'vue'
import fetchJsonp from 'fetch-jsonp'

VueHammer.config.swipe = {
    direction: 6
}
Vue.use(VueHammer)

window.jQuery = jQuery
window.$ = jQuery

// dependencies
require('../scss/styles.scss')
require('./vendors/fancySelect')
require('./vendors/jquery.magnificpop')
require('./vendors/slick')
const Cookies = require('./vendors/jquery.cookie')

// Globals
var isMobile = navigator.userAgent.match(
    /(iPhone|iPod|iPad|Android|BlackBerry|webOS)/
)
var isRetina = window.devicePixelRatio > 1 ? true : false

// Newsletter alert
let urlParams = new URLSearchParams(window.location.search)
if (urlParams.get('customer_posted') == 'true') {
}

// Register components in src/
// ===============================
const components = require.context('./components', true)
components.keys().map(component => {
    // turn './ComponentName.vue' into 'component-name'
    const componentName = _kebabCase(
        component.replace(/^\.\//, '').replace(/\.vue$/, '')
    )
    // register new component globally
    Vue.component(componentName, components(component).default)
})

// IIFE - DOM ready
//
// ====================================
;(function($) {
    const shopifyChallenge = document.querySelector(
        '.shopify-challenge__container'
    )
    new Vue({
        store,
        // mount just on header if we're on the captcha challenge page
        // otherwise, mount on entire container
        el: shopifyChallenge ? '#container > header' : '#container',
        data() {
            return {
                success: false,
                error: false
            }
        },
        mounted() {
            setTimeout(() => {
                let urlParams = new URLSearchParams(window.location.search)
                if (
                    !Cookies.get('modal') &&
                    (!urlParams.has('customer_posted') ||
                        urlParams.get('customer_posted') != 'true')
                ) {
                    document.body.classList.add('open-modal')
                } else if (urlParams.get('customer_posted') == 'true') {
                    this.success = true
                    Cookies.set('modal', 'true', { expires: 30 })
                    const successModal = document.querySelector(
                        '.modal--newsletter-success'
                    )
                    if (successModal) {
                        successModal.classList.add('opened')
                    }
                }
            }, 3000)
        },
        methods: {
            closeNewsletterModal() {
                document.body.classList.remove('open-modal')
                Cookies.set('modal', 'true', { expires: 30 })
            },
            closeSuccessModal() {
                const successModal = document.querySelector(
                    '.modal--newsletter-success'
                )
                if (successModal) {
                    successModal.classList.remove('opened')
                }
            },
            onNewsletterSuccess() {
                document
                    .querySelector('.newsletter__header')
                    .classList.add('hidden')
                document
                    .querySelector('#mc_embed_signup_modal')
                    .classList.add('hidden')
                document
                    .querySelector('.newsletter__footer')
                    .classList.remove('hidden')
            },
            async submitEmailFromModal(evt) {
                // build serialized form data
                const form = document.querySelector(
                    '#mc_embed_signup_modal form'
                )
                const formData = new FormData(form)
                const serialized = [...formData.entries()].map(e => {
                    return `${encodeURIComponent(e[0])}=${encodeURIComponent(
                        e[1]
                    )}`
                })

                // save url
                const url = evt.target.getAttribute('action')

                let message = ''
                await fetchJsonp(url + serialized.join('&'), {
                    jsonpCallback: 'c'
                })
                    .then(r => r.json())
                    .then(json => (this.success = json))
                    .catch(err => (this.error = err))

                const input = document.querySelector(
                    '#mc_embed_signup_modal.mc-email-signup'
                )
                input.parentNode.removeChild(input)

                if (this.success && this.success.result == 'success') {
                    document
                        .querySelector('.newsletter__header')
                        .classList.add('hidden')
                    document
                        .querySelector('.newsletter__footer')
                        .classList.remove('hidden')
                } else {
                    console.log(this.error)
                    document.querySelector('.newsletter__header').innerHTML =
                        'Error! Please contact us at <a href="mailto:shop@pretendstore.com">shop@pretendstore.com</a>.'
                }
            }
        }
    })

    // mobile class
    document.documentElement.classList.add(
        isMobile ? 'is-mobile' : 'not-mobile'
    )

    /*
     * Add hover class instead of touchevents
     */
    window.addEventListener(
        'mouseover',
        function onFirstHover() {
            document.documentElement.classList.add('has-hover')
            window.removeEventListener('mouseover', onFirstHover, false)
        },
        false
    )

    /**
     * Helpers
     */
    function validateEmail(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email)
    }

    /**
     * Variables to cache
     */
    var app = {
        viewportHeight: $(window).height(),
        viewportWidth: $(window).width(),

        controls: {
            scrollto: $('*[data-control-scrollto]')
        },

        newsletters: {
            $footer: $('.email-signup--footer'),
            $modal: $('.js-email-card'),
            modalActive: fromShopify.newsletter_active,
            success: fromShopify.newsletter_success
        },

        notification: {
            active: fromShopify.notification_active,
            message: fromShopify.notification_message
        },

        // Breakpoints
        bp: {
            xl: 1100.0,
            l: 992.0,
            m: 840.0,
            s: 700.0,
            xs: 480.0
        }
    }

    /**
     * Newsletter form submision
     */
    function mailchimpSignup($form, $formWrapper) {
        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action'),
            data: $form.serialize(),
            dataType: 'jsonp',
            success: function(data) {
                if (data.result == 'error') {
                    $('.js-initial').removeClass('is-active')
                    $('.js-error')
                        .html(data.msg)
                        .addClass('is-active')
                    $formWrapper
                        .find('.newsletter__footer')
                        .fadeIn(250)
                        .find('p')
                        .html(data.msg)
                        .addClass('message--error')
                } else {
                    console.log(data)
                    $('.js-email-card-form').removeClass('is-active')
                    $('.js-email-card-success').addClass('is-active')

                    // Check to see if it's a modal since modal has a header
                    if ($formWrapper.find('.newsletter__header').length) {
                        $('.newsletter__header').fadeOut(150)
                        Cookies.set('modalNewsletter', 'true', { expires: 365 })

                        setTimeout(function() {
                            jQuery.magnificPopup.close()
                        }, 4000)

                        $form.fadeOut(150, function() {
                            $formWrapper
                                .find('.newsletter__footer')
                                .fadeIn(250)
                                .find('p')
                                .html(app.newsletters.success)
                        })
                    } else {
                        setTimeout(function() {
                            $formWrapper
                                .find('.newsletter__footer')
                                .fadeOut(250, function() {
                                    $form.find('input[type="email"]').val('')
                                    $form.fadeIn(250)
                                })
                        }, 4000)

                        $form.fadeOut(150, function() {
                            $formWrapper
                                .find('.newsletter__footer')
                                .fadeIn(250)
                                .find('p')
                                .html(app.newsletters.success)
                        })
                    }
                }
            }
        })
    }

    // function sticky_relocate() {
    //   var window_top = $(window).scrollTop();
    //   var div_top = $('#sticky-anchor').offset().top;
    //   var content_height = $('#sticky').innerHeight();
    //   var window_width = $(window).width();
    //   if ((window_top > (div_top + content_height)) && (window_width > 700)){
    //       $('#sticky').addClass('stick');
    //       $('#sticky-anchor').height($('#sticky').outerHeight());
    //   } else if(window_top < div_top) {
    //       $('#sticky').removeClass('stick');
    //       $('#sticky-anchor').height(0);
    //     }
    // }

    // Purchasing
    if ($('.options').length > 0) {
        var optionID = false
        // console.log('OPTIONS 4 DAYZ');
    } else {
        var optionID = $('#option').attr('data-default-option-id')
        // console.log('NO OPTIONS');
    }

    $('.options-list').hide()
    // slides options list down
    $('.option-selected').click(function() {
        var optionsList = $('.options-list')
        if (optionsList.is(':visible')) {
            optionsList.slideUp(100)
        } else {
            optionsList.slideDown(100)
        }
    })

    // slides options list back up if you click anywhere on the page, if the options list is open
    $('body').click(function(e) {
        if (
            !$('.options').is(e.target) &&
            $('.options').has(e.target).length === 0
        ) {
            $('.options-list').slideUp(100)
        }
    })

    // choosing the actual option
    $('.options-list li').click(function() {
        var option = $(this).html()
        optionID = $(this).attr('data-option-id')
        $('.hidden-input').attr('value', optionID) // This was missing the period infront of the class name
        $('.option-selected-name').html(option)
        $('.options-list').hide()
        $('.options-wrap').height($('.options').outerHeight())
        $('.btn-purchase')
            .removeClass('btn-inactive')
            .addClass('btn-active')
        $('.btn-purchase span').html('Purchase')
    })

    var purchaseReady = true

    $('#addToBasket').on('submit', function(e) {
        if (!$('#option').val()) {
            e.preventDefault()
            $('.option-reminder').addClass('show')
            // console.log('no option selected');
        } else {
            if (purchaseReady) {
                purchaseReady = false
                setTimeout(function() {
                    purchaseReady = true
                }, 1000)
                var purchaseBtn = $(this)
                var purchaseText = purchaseBtn.find('span')
                if (optionID) {
                    Cart.addItem(optionID, 1, function(cart) {
                        e.preventDefault()
                        Cart.updateCount(cart)
                        setTimeout(function() {
                            purchaseText
                                .clone()
                                .appendTo(purchaseBtn)
                                .html('Purchase')
                                .hide()
                            purchaseBtn
                                .find('span')
                                .first()
                                .remove()
                            purchaseBtn
                                .find('span')
                                .first()
                                .fadeIn(400)
                        }, 800)
                    })
                }
            }
        }
    })

    /**
     * A simple share pop-up for Facebook
     */
    function sharePopup(href) {
        var h, left, shareWindow, top, w
        w = 600
        h = 300
        left = screen.width / 2 - w / 2
        top = screen.height / 2 - h / 2
        shareWindow = window.open(
            href,
            'Pretend Store',
            'location=1,status=1,scrollbars=1,width=' +
                w +
                ',height=' +
                h +
                ',top=' +
                top +
                ',left=' +
                left
        )
        return false
    }

    /**
     * scrollToElement
     */
    function scrollToElement(options) {
        var duration = options.duration || 250,
            easing = options.easing || 'easing',
            offset = options.offset || 0

        var target = options.target || false

        if (target) {
            if (/(iPhone|iPod)\sOS\s6/.test(navigator.userAgent)) {
                $('html, body').animate(
                    {
                        scrollTop: $(target).offset().top
                    },
                    duration,
                    easing
                )
            } else {
                $('html, body').animate(
                    {
                        scrollTop: $(target).offset().top - offset
                    },
                    duration,
                    easing
                )
            }
        }
    }

    /**
     * viewportSize
     */
    function viewportSize() {
        app.viewportHeight = $(window).height()
        app.viewportWidth = $(window).width()
    }

    /**
     * Lookbook Size
     */
    function lookbookSize() {
        if (app.viewportWidth > 700) {
            $('.single-lookbook .owl-wrapper-outer').css({
                height: app.viewportHeight - 160
            })
        }
    }

    // Cart Animate
    // ---------------------

    function cartRemoveAnimate($el, elID) {
        $el.slideUp(150, function(cart) {
            Cart.removeItem(elID)

            Cart.refresh(function(cart) {
                //console.log(JSON.stringify(cart, null, 4));
                var cartCountTotal =
                    cart.item_count < 10
                        ? '0' + cart.item_count
                        : cart.item_count

                $('.total-price').html(Format.money(cart.total))
                $('.menu-item--cart a').html('Cart ' + cartCountTotal)
                Cookies.set('cart_count', cart.item_count, { expires: 7 })
            })
        })
    }

    /**
     * WINDOW RESIZE
     */
    $(window)
        .resize(function() {
            viewportSize()
            lookbookSize()
        })
        .trigger('resize')

    function carouselButtonPosition() {
        var slideWidth = $('.slide-image').width()
        var slideHeight = $('.slide-image').height()
        var pos = (app.viewportWidth - slideWidth) / 8

        $('.btn--prev').css({
            left: pos,
            height: slideHeight
        })

        $('.btn--next').css({
            right: pos,
            height: slideHeight
        })
    }

    /**
     * Document ready
     */
    $(document).ready(function() {
        // Delay Loading of Images
        $('.product-images img').each(function() {
            var source = $(this).attr('data-src')
            var hdSource = $(this).attr('data-src-retina')
            if (hdSource != undefined && isRetina) {
                $(this)
                    .attr('src', hdSource)
                    .show()
            } else if (source != null) {
                $(this)
                    .attr('src', source)
                    .show()
            }
        })

        // Image Popups
        $('.single-product .product-images').magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Loading image #%curr%...',
            mainClass: 'mfp-product-gallery',
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
            },
            image: {
                tError:
                    '<a href="%url%">The image #%curr%</a> could not be loaded.'
            }
        })

        // Toggle Mobile Nav
        if (isMobile || app.viewportWidth < app.bp.m) {
            $('.mobile-menu-toggle').on('click', function(event) {
                event.preventDefault()
                $('body').toggleClass('mobile-nav-visible')
                // $(this).toggleClass('logo-type');
            })
        }

        // Facebook Share popup
        $('.js-share_popup').on('click', function(event) {
            event.preventDefault()

            return sharePopup($(this).attr('href'))
        })

        // Lookbook Carousel
        if ($('#shopify-section-lookbook').length) {
            // Slick Carousel
            $('.slider--lookbook').on('init', function() {
                $('.slider-container').removeClass('loading')
            })

            var $lookbookCarousel = $('.slider--lookbook').slick({
                slidesToShow: 1,
                infinite: false,
                dots: true,
                appendDots: $('.dots-container'),
                lazyLoad: 'ondemand',
                fade: true,
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: app.bp.s,
                        settings: {
                            arrows: false
                        }
                    }
                ]
            })

            $('.btn--back').on('click', function() {
                window.history.back()
            })
        }

        // What is this?
        $('.dropdown-toggle').on('click', function(e) {
            e.preventDefault()
            var $this = $(this),
                $dropdown = $this.parent()

            $($dropdown).toggleClass('dropdown-active')
        })

        // Home page Carousel
        if ($('.homeslider-container .slider').length > 0) {
            // Slick Carousel
            $('.slider').on('init', function() {
                $('.homeslider-container').removeClass('loading')

                if (app.viewportWidth >= app.bp.s) {
                    var marginTop =
                        $('.slide-image').height() - $('.slick-slider').height()
                    $('.dots-container').css({ 'margin-top': marginTop })
                }
            })

            $('.slider').on('breakpoint', function() {
                if (app.viewportWidth >= app.bp.s) {
                    var marginTop =
                        $('.slide-image').height() - $('.slick-slider').height()
                    $('.dots-container').css({ 'margin-top': marginTop })
                } else {
                    $('.dots-container').css({ 'margin-top': '0' })
                }
            })

            var $homeCarousel = $('.slider').slick({
                slidesToShow: 1,
                infinite: true,
                dots: true,
                appendDots: $('.dots-container .inner'),
                lazyLoad: 'ondemand',
                fade: true,
                cssEase: 'linear',
                responsive: [
                    {
                        breakpoint: app.bp.s,
                        settings: {
                            arrows: false
                        }
                    }
                ]
            })
        }

        /**
         * Newsletter footer
         */
        app.newsletters.$footer
            .find('button[type="submit"]')
            .on('click', function(event) {
                event.preventDefault()
                var $form = app.newsletters.$footer.find('form')
                var $formFooter = app.newsletters.$footer.find(
                    '.newsletter__footer'
                )

                if (validateEmail($form.find('input[type="email"]').val())) {
                    if ($formFooter.find('p').hasClass('has-error')) {
                        $formFooter
                            .fadeOut(100)
                            .find('p')
                            .removeClass('has-error')
                    }
                    mailchimpSignup($form, app.newsletters.$footer)
                } else {
                    $formFooter
                        .fadeIn(150)
                        .find('p')
                        .addClass('has-error')
                        .html('Please provide a correct email address')
                }
            })

        function newsletterModal() {
            var $form = app.newsletters.$modal.find('form')
            var $formFooter = app.newsletters.$modal.find('.newsletter__footer')
            var $formCard = app.newsletters.$modal.find('.js-email-card-form')
            var location = 'modal'
            $('.js-email-card-target').on('submit', function(event) {
                $('.js-error').removeClass('is-active')
                event.preventDefault()
                if (validateEmail($form.find('input[type="email"]').val())) {
                    $('.js-invalid').removeClass('is-active')
                    if ($formCard.find('p').hasClass('has-error')) {
                        $formCard
                            .fadeOut(100)
                            .find('p')
                            .removeClass('has-error')
                    }
                    mailchimpSignup($form, app.newsletters.$modal)
                } else {
                    $('.js-initial').removeClass('is-active')
                    $('.js-invalid').addClass('is-active')
                }
            })
        }

        // The toast thing
        // function newsletterToast () {
        //   $(".js-email-toast").delay(2000).addClass('is-active')
        //   $(".js-email-toast").on('click', function() {
        //     $(".js-email-toast").removeClass('is-active')
        //     let offset = $('.js-email-card').offset().top - 60
        //     $('html').animate({scrollTop: offset});
        //   })
        //   console.log('set up scroll listener')
        //   $(document).on('scroll', function() {
        //     if ($('.js-email-toast').offset().top > $('.js-email-card').offset().top) {
        //       if ( !$('.js-toast-arrow').hasClass('is-rotated') ) {
        //         console.log('flip')
        //         $('.js-toast-arrow').addClass('is-rotated')
        //       }
        //     } else {
        //       if ($('.js-toast-arrow').hasClass('is-rotated')) {
        //         console.log('flop')
        //         $('.js-toast-arrow').removeClass('is-rotated')
        //       }
        //     }
        //   });
        // }

        /**
         * Show newsletter modal if cookie isn't set
         */
        if (
            Cookies.get('modalNewsletter') != 'true' &&
            $('#shopify-section-lookbook').length <= 0 &&
            app.newsletters.modalActive == 'true'
        ) {
            $('.js-email-card').addClass('is-active')
            Cookies.set('modalNewsletter', 'true', { expires: 365 })
            newsletterModal()
            // newsletterToast();
        } else {
            $('.js-email-card').addClass('is-active')
            newsletterModal()
            // newsletterToast();
        }

        /**
         * Notification bar
         */
        if (app.notification.active == 'true') {
            notificationBar()
        }

        function notificationBar() {
            var notificationBar = $('.notification')
            notificationBar
                .addClass('is-visible')
                .find('p')
                .html(app.notification.message)
        }
        $('.notification-close').on('click', function(event) {
            event.preventDefault()

            // Cookies.set('notificationBar', 'true');
            $('.notification').removeClass('is-visible')
        })

        // Store Features
        $('.artist-listing .block:nth-child(even)').addClass('even')
        $('.artist-listing .block:nth-child(odd)').addClass('odd')
        $('.artist-listing .block:nth-child(4n)').addClass('last')

        if ($('body').hasClass('bc-store')) {
            $('.product-block').each(function() {
                var priceText = $(this)
                    .find('.price-wrap')
                    .text()
                var index = priceText.indexOf('.')

                $(this)
                    .find('.price-wrap')
                    .text(priceText.substring(index, -1))
            })
        }

        if ($('body').hasClass('bc-store') && $('body').hasClass('product')) {
            var priceText = $('.product-price').text()
            var index = priceText.indexOf('.')

            $('.product-price').text(priceText.substring(index, -1))
        }

        /**
         ** Cart Actions
         */

        // Cart item removal
        $('.btn--remove').click(function(event) {
            var itemID = $(this).attr('data-item-id'),
                $item = $(this).closest('.cart-product')

            cartRemoveAnimate($item, itemID)
        })
    })

    // Sticky Nav
    function prep_sticky(container, node) {
        return function(e) {
            var top = window.pageYOffset
            if (
                ($(window).width() < 700) |
                (node.height() > container.height())
            ) {
                $('.js-sticky').removeClass('stick')
                return
            }
            var maxHeight =
                container.height() - node.height() + container.offset().top
            if (top > maxHeight) {
                $('.js-sticky').removeClass('stick')
                $('.js-sticky').css(
                    'margin-top',
                    container.height() - node.height()
                )
            } else {
                $('.js-sticky').addClass('stick')
                $('.js-sticky').css('margin-top', 0)
            }
            if (top < container.offset().top) {
                $('.js-sticky').removeClass('stick')
                $('.js-sticky').css('margin-top', 0)
            }
        }
    }

    function watch_sticky() {
        var containerNode = $('.js-sticky-container')
        var stickyNode = $('.js-sticky')
        var watch = prep_sticky(containerNode, stickyNode)
        if (stickyNode.length > 0) {
            $(window).scroll(watch)
        }
    }
    watch_sticky()
    // sticky_relocate();

    $('#product-select').fancySelect()

    // toggle stock reveal
    $(document).on('click', '.stock-notification .expand', function() {
        document.body.classList.add('stock-signup-visible')
    })
})(jQuery)
